"use client";
import Link from "next/link";
import React, { Suspense } from "react";
import { IoMdReturnRight } from "react-icons/io";
import Skeleton from "react-loading-skeleton";
import { useSearchParams } from "next/navigation";

interface DropdownItemsProps {
  availableFilters: string[];
  setIsActive: (isActive: boolean) => void;
  toggleHamburgerMenu?: () => void;
  typeOfDropdown: TypeDropdown;
  option: string;
}

const DropdownItems = ({
  availableFilters,
  setIsActive,
  toggleHamburgerMenu,
  typeOfDropdown,
  option,
}: DropdownItemsProps) => {
  const searchParams = useSearchParams();

  const getHref = (category: string) => {
    switch (typeOfDropdown) {
      case "categoryFilter":
        return `/${option}?page=1&category_like=${category}`;
      case "inPage":
        return `/${option}#${category.toLocaleLowerCase()}`;
      case "toPage":
        return `${option}`;
      default:
        return "#";
    }
  };

  return (
    <Suspense fallback={<Skeleton />}>
      {availableFilters.map((category) => (
        <li key={category}>
          <Link
            className={`${
              typeOfDropdown === "categoryFilter" &&
              searchParams.get("category_like") === category
                ? "active"
                : ""
            }`}
            onClick={() => {
              /* setIsActive(false); */ //!CLOSE OR NOT ?!
              toggleHamburgerMenu && toggleHamburgerMenu();
            }}
            href={getHref(category)}
          >
            <IoMdReturnRight className="arrow-right-dropdown" size={15} />
            {category.replace(/-/g, " ")}
          </Link>
        </li>
      ))}
    </Suspense>
  );
};

export default DropdownItems;
